export const GAME_SERVER_OPTIONS = [
  {
    label: "汉将无双-正式服",
    helper: "http://111.231.174.15:9100/",
    value: "111.231.174.15:9100",
    serverId: "s1",
  },
]

export const DEFAULT_GAME_SERVER = GAME_SERVER_OPTIONS[0].value
